// extracted by mini-css-extract-plugin
export default {"filter":"Onboarding_filter__usdJm","clock":"Onboarding_clock__cbyQ9"};